import { parseDateOnly } from '@/utils/dateOnly';

/** "$5,000" (whole dollars) for contract text; "N/A" when missing. */
export function formatContractMoney(value?: number | string | null): string {
  const n = Number(value);
  if (value == null || value === '' || !Number.isFinite(n)) return 'N/A';
  return `$${n.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
}

/** "November 20, 2026" for contract text (date-only strings, no UTC shift). */
export function formatContractDate(value?: string | null): string {
  const d = parseDateOnly(value);
  return d
    ? d.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      })
    : 'N/A';
}

/**
 * First sentence of the Titles, Surveys, and Costs clause. Names the title
 * company when the buyer chose one (it previously always said "a reputable
 * title company"), and doesn't print "Within [blank] days" when no
 * days-to-select was needed.
 */
export function titleOrderSentence(opts: {
  titleCompany?: string | null;
  daysToSelectTitleCompany?: number | string | null;
}): string {
  const company = (opts.titleCompany || '').trim();
  const days = Number(opts.daysToSelectTitleCompany);
  const when =
    Number.isFinite(days) && days > 0
      ? `Within ${days} days from the Execution Date of this Agreement`
      : 'Promptly after the Execution Date of this Agreement';
  const from = company
    ? `${company} (the "Title Company")`
    : 'a reputable title company';
  return `${when}, Buyer will order from ${from} for delivery to Seller a comprehensive title report on the Property. Upon receipt, Buyer will deliver a free copy of the title report to Seller.`;
}
